// extracted by mini-css-extract-plugin
export default {"Container":"Cards_Container__7kupo","Cards-wrapper":"Cards_Cards-wrapper__l+RvF","card":"Cards_card__+ESYg","icon-wrapper":"Cards_icon-wrapper__BO93x"};